import {
  SCHEDULEANDCANDIDATES_FETCHING,
  SCHEDULEANDCANDIDATES_FAILED,
  SCHEDULEANDCANDIDATES_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SCHEDULEANDCANDIDATES_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case SCHEDULEANDCANDIDATES_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case SCHEDULEANDCANDIDATES_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
